import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import {
  AccuracyDisplay,
  GammaAccuracy,
  GammaAccuracyDefinition,
} from "@/types/location/location-accuracy";
import { LOCATION_ACCURACY } from "@/constants/location-accuracy";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrecisionAccuracy',
  props: {
  precisionAccuracy: {
    type: Number as PropType<GammaAccuracy>,
  },
},
  setup(__props) {

const props = __props;



const def = computed<GammaAccuracyDefinition | undefined>(() =>
  props.precisionAccuracy
    ? LOCATION_ACCURACY[props.precisionAccuracy]
    : undefined
);

const backgroundColor = computed<string>(() => {
  switch (def.value?.accuracy) {
    case AccuracyDisplay.Low:
      return "#f32";
    case AccuracyDisplay.High:
      return "#3f2";
    default:
      return "#999";
  }
});

const hasAccuracy = computed(() => typeof props.precisionAccuracy === "number");

return { __sfc: true,props, def, backgroundColor, hasAccuracy }
}

})